<template>
  <div class="page">
    <!-- user图表 -->
    <div class="user-icon">
      <van-image  height="50px"   :src="require('../../image/logo_title.png')" />
    </div>
    <!-- 表单 -->
    <van-form @submit="onSubmit">
      <div class="input-group van-hairline--surround">
        <!-- 用户名 -->
        <van-field
          v-model="phoneNumber"
          name="username"
          placeholder="用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
        >
          <template #left-icon>
            <div class="left-icon"><van-icon name="user-o" /></div>
          </template>
        </van-field>
        <!-- 短信验证码 -->
        <!-- <van-field
          v-model="verificationCode"
          name="verificationCode"
          placeholder="请填写短信验证码"
          autocomplete
          :rules="[{ required: true, message: '请填写短信验证码' }]"
        >
          <template #left-icon>
            <div class="left-icon"><van-icon name="envelop-o" /></div>
          </template>
          <template #button>
            <div class="verification-button">发送验证码</div>
          </template>
        </van-field> -->
        <!-- 密码 -->
        <van-field
          v-model="password"
          type="password"
          name="password"
          placeholder="密码"
          autocomplete
          :rules="[{ required: true, message: '请填写密码' }]"
        >
          <template #left-icon>
            <div class="left-icon"><van-icon name="eye-o" /></div>
          </template>
        </van-field>
      </div>
      <div class="forgetDiv">
         <router-link style="padding: 0 16px;font-size: 12px;color: #666" to='/resetPassword'>忘记密码</router-link>
      </div>
      <!-- 按钮 -->
      <div class="btns">
        <van-button block  type="primary"   native-type="submit" :loading="loading" :disabled="loading" loading-text="登录中...">
          登录
        </van-button>
      </div>
<!--      <div id="process">-->
<!--        aaa-->
<!--      </div>-->
    </van-form>
  </div>
</template>

<script>
// import { toRefs, reactive, onMounted } from 'vue'
import { toRefs, reactive } from 'vue'
import useLogin, { state } from '@/hooks/useLogin' // 登录逻辑 loading onSubmit state
// import { DataSet, Network } from 'vis'
import base from '@/utils/base64'
export default {
  name: 'Login',
  setup () {
    const userInfo = reactive({
      phoneNumber: '',
      password: ''
    })
    const initUserInfo = () => {
      const username = localStorage.getItem('username')
      const password = localStorage.getItem('password')
      if (username !== '' && username !== null && password !== '' && password !== null) {
        userInfo.phoneNumber = base.decode(username)
        userInfo.password = base.decode(password)
      }
    }
    initUserInfo()
    // const globalTrace = () => {
    //   // create an array with nodes
    //   const nodes = new DataSet([
    //     { id: 1, label: 'Node 1' },
    //     { id: 2, label: 'Node 2' },
    //     { id: 3, label: 'Node 3' },
    //     { id: 4, label: 'Node 4' },
    //     { id: 5, label: 'Node 5' }
    //   ])
    //   // create an array with edges
    //   const edges = new DataSet([
    //     { from: 1, to: 1 },
    //     { from: 2, to: 3 },
    //     { from: 2, to: 4 },
    //     { from: 2, to: 5 }
    //   ])
    //   // create a network
    //   const container = document.getElementById('process')
    //   // provide the data in the vis format
    //   const data = {
    //     nodes: nodes,
    //     edges: edges
    //   }
    //   const options = {
    //     // 节点样式
    //     nodes: {
    //       shape: 'box', // 设置节点node样式为矩形
    //       fixed: true, // 节点node固定不可移动
    //       font: {
    //         color: 'white', // 字体的颜色
    //         size: 30 // 显示字体大小
    //       },
    //       scaling: {
    //         min: 16,
    //         max: 32 // 缩放效果比例
    //       }
    //     },
    //     // 连接线的样式
    //     edges: {
    //       color: {
    //         color: 'rgb(97, 168, 224)',
    //         highlight: 'rgb(97, 168, 224)',
    //         hover: 'green',
    //         inherit: 'from',
    //         opacity: 1.0
    //       },
    //       font: {
    //         align: 'top' // 连接线文字位置
    //       },
    //       smooth: true, // 是否显示方向箭头
    //       arrows: { to: true } // 箭头指向from节点
    //     },
    //     layout: {
    //       // 以分层方式定位节点
    //       hierarchical: {
    //         direction: 'LR', // 分层排序方向
    //         sortMethod: 'directed', // 分层排序方法
    //         levelSeparation: 400 // 不同级别之间的距离
    //       }
    //     },
    //     interaction: {
    //       navigationButtons: true,
    //       // hover: true, //鼠标移过后加粗该节点和连接线
    //       selectConnectedEdges: false // 选择节点后是否显示连接线
    //     }
    //   }
    //   // initialize your network!
    //   const network = new Network(container, data, options)
    //   network.on('click', e => this.showDetail(e)) // 单击事件
    //   network.on('doubleClick', e => this.enterService(e)) // 双击事件
    // }
    // onMounted(() => {
    //   globalTrace()
    // })

    return { ...useLogin, ...toRefs(state), initUserInfo, ...toRefs(userInfo) }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  background-image: url("../../image/log_bg.png");
  background-repeat:no-repeat;
  background-position:right;
  background-size: contain;
  .user-icon {
    text-align: left;
    font-size: 106px;
    color: #ccc;
    padding: 70px 20px 10px 50px;
  }
  .input-group {
    margin: 16px 50px 0 50px;
    .left-icon {
      width: 30px;
    }
    .verification-button {
      font-size: 12px;
      border: 1px solid #1989fa;
      padding: 0 5px;
      border-radius: 5px;
      color: #1989fa;
    }
  }
  .btns {
    margin: 20px 100px 0px 80px;
  }
  .forgetDiv{
    text-align: right;
    margin-right: 30px;
    margin-top: 10px;
  }
}
#process {
  width: 200px;
  height: 200px;
  border: 1px solid lightgray;
}
</style>
